import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import apiConfig from 'constants/apiConfig';
import { keys } from 'components/IncidentConfig/hooks/useGetIncidentPositionInfo';
import { keys as rosterKeys } from 'hooks/incident/useRoster';
import { incidentRosterKeys } from 'components/IAP/hooks/incidentRoster/incidentRoster.queryKeys';
import { rosterResourcesKeys } from 'components/IAP/hooks/incidentRosterResources/incidentRosterResources';

interface UpdatePositionAndRoleParams {
  incidentId: string;
  position: {
    id: string;
    name: string;
  };
  permissions: {
    id: string;
  }[];
}

export const useUpdatePositionAndRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdatePositionAndRoleParams) => {
      const response = await axios.post(
        apiConfig.apiGateway.incidentPositionAndRole,
        params
      );
      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: keys.byPosition(variables.incidentId, variables.position.id),
      });
      // The org chart, roster and resources all display the position name.
      queryClient.invalidateQueries({
        queryKey: [rosterKeys.incidentPositions, variables.incidentId],
      });
      queryClient.invalidateQueries({
        queryKey: incidentRosterKeys.byIncident(variables.incidentId),
      });
      queryClient.invalidateQueries({
        queryKey: incidentRosterKeys.draftByIncident(variables.incidentId),
      });
      queryClient.invalidateQueries({
        queryKey: rosterResourcesKeys.byIncident(variables.incidentId),
      });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.ERROR || 'Failed to update position and role'
      );
    },
  });
};
